import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CreateTrackingLink, TrackingLink, VehicleLocationDto } from '@fleet-beat/api';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyV2Dto,
  ResponseDto,
  SimpleResponseDto,
} from '@fleet-beat/core';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TruckTrackingApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/tracking-links`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  // NOTE | Tracking link - this is the entity name of tracking object
  getTrackingLinks(auth: AuthHeaders, params?: GetManyV2Dto): Observable<TrackingLink[]> {
    return this.baseApiService.get(`${this.baseUrl}`, { auth, params }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<TrackingLink[]>) => this.baseApiService.mapResponse(response)),
    );
  }

  createTrackingLink(body: CreateTrackingLink, auth: AuthHeaders): Observable<TrackingLink> {
    return this.baseApiService.post(`${this.baseUrl}`, body, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<TrackingLink>) => this.baseApiService.mapResponse(response)),
    );
  }

  deleteTrackingLink(id: string, auth: AuthHeaders): Observable<SimpleResponseDto> {
    return this.baseApiService
      .delete(`${this.baseUrl}/${id}`, { auth })
      .pipe(catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)));
  }

  // NOTE | Here is the link itself (url + token), do not confuse with "Tracking link"
  generateLink(id: string, auth: AuthHeaders): Observable<{ url: string }> {
    return this.baseApiService.get(`${this.baseUrl}/${id}/generate`, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<{ url: string }>) => this.baseApiService.mapResponse(response)),
    );
  }
}
